var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.paramsData.id == 1 ? _vm.$t("modify") : _vm.$t("ban"),
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "uids", label: _vm.$t("playerId") }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: {
                      disabled: _vm.paramsData.is_abnormal_op,
                      placeholder: _vm.$t("playerIdPlaceholder")
                    },
                    model: {
                      value: _vm.paramsData.uids,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "uids", $$v)
                      },
                      expression: "paramsData.uids"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "expire_time", label: _vm.$t("banTime") }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      "value-format": "timestamp",
                      type: "datetime",
                      placeholder: _vm.$t("date")
                    },
                    model: {
                      value: _vm.paramsData.expire_time,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "expire_time", $$v)
                      },
                      expression: "paramsData.expire_time"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: _vm.$t("banType") }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.paramsData.op_type,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "op_type", $$v)
                        },
                        expression: "paramsData.op_type"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, border: "" } }, [
                        _vm._v(_vm._s(_vm.$t("banAccount")))
                      ]),
                      _c("el-radio", { attrs: { label: 0, border: "" } }, [
                        _vm._v(_vm._s(_vm.$t("mute")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "flex lodingItem-title first_box",
                  staticStyle: {
                    "margin-bottom": "20px",
                    width: "100%",
                    "align-items": "center"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("reason")) + ": ")]
              ),
              _c(
                "el-form-item",
                { staticStyle: { width: "100%" }, attrs: { prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 12 },
                      placeholder: _vm.$t("pleaseEnter")
                    },
                    model: {
                      value: _vm.paramsData.reason,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "reason", $$v)
                      },
                      expression: "paramsData.reason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }